import { Images, QuestionGroup, QuestionType, ScenarioStep, Steps } from '../state/interfaces'
import { emailAddress } from './common-steps'

export const emailAddressCountry: ScenarioStep = {
  ...emailAddress,
  next: Steps.COUNTRY,
}

export const country: ScenarioStep = {
  id: Steps.COUNTRY,
  group: QuestionGroup.DEFAULT,
  question: 'country_question',
  tip: 'country_tip',
  type: QuestionType.INPUT_AUTOCOMPLETE,
  answerPlaceholder: 'country_answerPlaceholder',
  next: Steps.THANKS_COUNTRY,
  answers: [],
  metadata: { grandImage: Images.TRAVEL },
}

export const thanksCountry: ScenarioStep = {
  id: Steps.THANKS_COUNTRY,
  group: QuestionGroup.DEFAULT,
  question: 'thanks-country_question',
  type: QuestionType.CHOICE_AS_MAIN_PILL,
  next: Steps.DONE,
  answers: [
    {
      id: 'close',
      text: 'common_close',
    },
  ],
  metadata: { grandImage: Images.REVIEW_11 },
}
